function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0_rem{fill:#FDB614;}\n\t.st1_rem{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0_rem",
  d: "M35.5,6.1C27.4-2,14.2-2,6.1,6.1s-8.1,21.3,0,29.4s21.3,8.1,29.4,0S43.6,14.2,35.5,6.1L35.5,6.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1_rem",
  d: "M30.5,19.1H19h-0.8h-7.4c-0.9,0-1.6,0.8-1.6,1.6c0,0.9,0.8,1.6,1.6,1.6h7.5h0.8h11.5c0.9,0,1.6-0.8,1.6-1.6 C32.2,19.9,31.5,19.2,30.5,19.1z"
});

var SvgRemoveMinus = function SvgRemoveMinus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "41.6px",
    height: "41.6px",
    viewBox: "0 0 41.6 41.6",
    style: {
      enableBackground: "new 0 0 41.6 41.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveMinus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-minus.0fde5360.svg";
export { ForwardRef as ReactComponent };